(() => {
  if (window.troopGiftManager) return;

  window.troopGiftHasOtherAutomaticDiscount = function (cart) {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const rules = [
      ...(Array.isArray(window.freeGiftRules) ? window.freeGiftRules : []),
      ...(Array.isArray(window.nonFreeGiftRules) ? window.nonFreeGiftRules : [])
    ];
    const giftVariantIds = new Set(rules.map(rule => Number(rule.freeGiftVariantId)).filter(Boolean));
    const isGiftLine = item => {
      const properties = item.properties || {};
      return properties._is_free_gift === 'true' ||
        Boolean(properties._auto_free_gift_rule) ||
        properties._troop_manual_gift === 'true' ||

        (giftVariantIds.has(Number(item.variant_id)) && Number(item.final_line_price) === 0);
    };
    const gifts = items.filter(isGiftLine);
    const regularItems = items.filter(item => !isGiftLine(item));
    const allocations = item => [
      ...(Array.isArray(item.line_level_discount_allocations) ? item.line_level_discount_allocations : []),
      ...(Array.isArray(item.discount_allocations) ? item.discount_allocations : [])
    ];
    const isCode = application => {
      const type = String(application?.type || '').toLowerCase();
      return type === 'discount_code' || type === 'code';
    };
    const amount = value => Math.max(0, Number(value) || 0);


    const hasOtherLineDiscount = item => {
      const applied = allocations(item).filter(a => amount(a.amount) > 0);
      if (applied.some(a => !isCode(a.discount_application))) return true;
      const identifiedCodeDiscount = applied.reduce((sum, a) => sum + amount(a.amount), 0);
      const fallbackDiscount = Math.max(
        amount(item.line_level_total_discount),
        amount(item.total_discount),
        (Array.isArray(item.discounts) ? item.discounts : []).reduce((sum, d) => sum + amount(d.amount), 0),
        amount(Number(item.original_line_price) - Number(item.final_line_price))
      );

      return fallbackDiscount > identifiedCodeDiscount;
    };

    if (regularItems.some(hasOtherLineDiscount)) return true;

    for (const application of cart?.cart_level_discount_applications || []) {
      if (isCode(application) || amount(application?.total_allocated_amount) <= 0) continue;
      const hasApplication = item =>
        (item.discounts || []).some(discount =>
          discount.title === application.title && amount(discount.amount) > 0
        ) || allocations(item).some(allocation => {
          const applied = allocation.discount_application;
          return amount(allocation.amount) > 0 && applied &&
            ((application.key && applied.key && application.key === applied.key) ||
             (application.title && applied.title === application.title));
        });


      if (regularItems.some(hasApplication)) return true;
      if (!gifts.some(hasApplication)) return true;
    }
    return false;
  };
  class TroopGiftManager {
    constructor() {
      this.nativeFetch = window.fetch.bind(window);
      this.busy = false;
      this.pending = false;
      this.timer = null;
      this.loading = false;
      this.cartMutationTime = 0;
      this.refreshTime = 0;
      this.loaderCheck = null;
      this.loaderFailsafe = null;
      this.emptyCheck = null;
      this.install();
    }
    get freeRules() { return Array.isArray(window.freeGiftRules) ? window.freeGiftRules : []; }
    get nonFreeRules() { return Array.isArray(window.nonFreeGiftRules) ? window.nonFreeGiftRules : []; }
    url(path) { return `${window.Shopify?.routes?.root || '/'}${path}`; }
    async request(path, payload) {
      const response = await this.nativeFetch(this.url(path), payload ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) } : { headers: { Accept: 'application/json' }, cache: 'no-store' });
      const body = await response.json();
      if (!response.ok || body.status) throw new Error(body.description || body.message || `Cart HTTP ${response.status}`);
      return body;
    }
    cart() { return this.request('cart.js'); }
    isGift(item) { return item.properties?._is_free_gift === 'true' || Boolean(item.properties?._auto_free_gift_rule); }
    validDate(rule) {
      const now = new Date();
      for (const [value, end] of [[rule.startDate, false], [rule.endDate, true]]) {
        if (!value) continue;
        const d = /^\d{4}-\d{2}-\d{2}$/.test(String(value)) ? new Date(`${value}T${end ? '23:59:59' : '00:00:00'}`) : new Date(value);
        if (Number.isNaN(d.getTime())) return false;
        if ((end && now > d) || (!end && now < d)) return false;
      }
      return true;
    }
    total(cart) {
      return cart.items.filter(item => !this.isGift(item) && item.properties?._troop_manual_gift !== 'true').reduce((sum, item) => sum + Number(item.final_line_price ?? item.line_price ?? 0), 0);
    }
    eligible(rule, cart) {
      if (!rule?.enabled || !Number(rule.freeGiftVariantId) || !this.validDate(rule)) return false;
      if (rule.condition === 'price') return Number(rule.freeGiftPrice) > 0 && this.total(cart) >= Number(rule.freeGiftPrice);
      if (rule.condition === 'collection') {
        const ids = (rule.eligibleProductIds || []).map(Number);
        return ids.length > 0 && cart.items.some(item => !this.isGift(item) && item.properties?._troop_manual_gift !== 'true' && ids.includes(Number(item.product_id)));
      }
      return false;
    }
    matchingRule(cart) { return this.freeRules.find(rule => this.eligible(rule, cart)) || null; }
    carts() { return document.querySelectorAll('cart-element.cart--root[data-view="drawer"], cart-element.cart--root[data-view="desktop"]'); }
    installLoader() {
      if (document.getElementById('troop-gift-loader-style')) return;
      const style = document.createElement('style');
      style.id = 'troop-gift-loader-style';
      style.textContent = `.cart--root[data-view="drawer"]{position:relative}.troop-gift-loading-overlay{position:absolute;inset:0;z-index:50;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.72);opacity:0;visibility:hidden;transition:opacity .2s ease,visibility .2s ease;pointer-events:none}.troop-gift-loading-overlay.is-active{opacity:1;visibility:visible;pointer-events:auto}.troop-gift-loading-overlay[data-view="desktop"]{position:fixed;inset:0;width:100vw;height:100vh;height:100dvh;z-index:9999}.troop-gift-loading-spinner{width:28px;height:28px;display:block;color:#348bd7;animation:troop-gift-spin .8s linear infinite}@keyframes troop-gift-spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`;
      document.head.appendChild(style);
    }
    ensureLoader() {
      let lastOverlay = null;
      const drawer = document.querySelector('cart-element.cart--root[data-view="drawer"]');
      const page = document.querySelector('cart-element.cart--root[data-view="desktop"]');
      if (drawer) {
        let overlay = drawer.querySelector(':scope > .troop-gift-loading-overlay');
        if (!overlay) {
          overlay = this.createOverlay('drawer');
          drawer.appendChild(overlay);
        }
        overlay.classList.toggle('is-active', this.loading);
        lastOverlay = overlay;
      }
      let pageOverlay = document.getElementById('troop-gift-page-overlay');
      if (page) {
        if (!pageOverlay) {
          pageOverlay = this.createOverlay('desktop');
          pageOverlay.id = 'troop-gift-page-overlay';
          document.body.appendChild(pageOverlay);
        }
        pageOverlay.classList.toggle('is-active', this.loading);
        lastOverlay = pageOverlay;
      } else if (pageOverlay) pageOverlay.remove();
      return lastOverlay;
    }
    createOverlay(view) {
      const overlay = document.createElement('div');
      overlay.className = 'troop-gift-loading-overlay';
      overlay.dataset.view = view;
      overlay.setAttribute('aria-hidden', 'true');
      overlay.innerHTML = `<svg class="troop-gift-loading-spinner" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><g transform="translate(20 20)"><line x1="0" y1="-14" x2="0" y2="-9" stroke="currentColor" stroke-width="3" stroke-linecap="round" opacity="1"/><line x1="7" y1="-12.12" x2="4.5" y2="-7.8" stroke="currentColor" stroke-width="3" stroke-linecap="round" opacity=".92"/><line x1="12.12" y1="-7" x2="7.8" y2="-4.5" stroke="currentColor" stroke-width="3" stroke-linecap="round" opacity=".84"/><line x1="14" y1="0" x2="9" y2="0" stroke="currentColor" stroke-width="3" stroke-linecap="round" opacity=".76"/><line x1="12.12" y1="7" x2="7.8" y2="4.5" stroke="currentColor" stroke-width="3" stroke-linecap="round" opacity=".68"/><line x1="7" y1="12.12" x2="4.5" y2="7.8" stroke="currentColor" stroke-width="3" stroke-linecap="round" opacity=".60"/><line x1="0" y1="14" x2="0" y2="9" stroke="currentColor" stroke-width="3" stroke-linecap="round" opacity=".52"/><line x1="-7" y1="12.12" x2="-4.5" y2="7.8" stroke="currentColor" stroke-width="3" stroke-linecap="round" opacity=".44"/><line x1="-12.12" y1="7" x2="-7.8" y2="4.5" stroke="currentColor" stroke-width="3" stroke-linecap="round" opacity=".36"/><line x1="-14" y1="0" x2="-9" y2="0" stroke="currentColor" stroke-width="3" stroke-linecap="round" opacity=".28"/><line x1="-12.12" y1="-7" x2="-7.8" y2="-4.5" stroke="currentColor" stroke-width="3" stroke-linecap="round" opacity=".20"/><line x1="-7" y1="-12.12" x2="-4.5" y2="-7.8" stroke="currentColor" stroke-width="3" stroke-linecap="round" opacity=".12"/></g></svg>`;
      return overlay;
    }
    showLoader() {
      if (!this.loading) this.cartMutationTime = 0;
      this.loading = true;
      this.refreshTime = 0;
      this.ensureLoader();
      clearTimeout(this.loaderFailsafe);
      this.loaderFailsafe = setTimeout(() => this.hideLoader(), 12000);
    }
    hideLoader() {
      this.loading = false;
      this.refreshTime = 0;
      clearTimeout(this.loaderCheck);
      clearTimeout(this.loaderFailsafe);
      this.ensureLoader();
    }
    checkLoader() {
      clearTimeout(this.loaderCheck);
      if (!this.loading || this.busy || this.pending || this.timer) return;
      if (this.refreshTime && this.cartMutationTime < this.refreshTime) return;
      this.loaderCheck = setTimeout(() => {
        if (!this.busy && !this.pending && !this.timer && (!this.refreshTime || this.cartMutationTime >= this.refreshTime)) this.hideLoader();
      }, 280);
    }
    installEmptyCartStyle() {
      if (document.getElementById('troop-gift-empty-cart-style')) return;
      const style = document.createElement('style');
      style.id = 'troop-gift-empty-cart-style';
      style.textContent = `.cart--root.troop-gift-cart-empty .cart--item,.cart--root.troop-gift-cart-empty .cart--headings,.cart--root.troop-gift-cart-empty .cart--notes,.cart--root.troop-gift-cart-empty .cart--summary,.cart--root.troop-gift-cart-empty .cart--shipping,.cart--root.troop-gift-cart-empty .cart--footer{display:none!important}.cart--root.troop-gift-cart-empty .cart--empty,.cart--root.troop-gift-cart-empty .cart--empty-text{display:block!important}`;
      document.head.appendChild(style);
    }
    updateEmptyCart(cart) {
      const empty = Number(cart.item_count) === 0;
      this.installEmptyCartStyle();
      document.querySelectorAll('cart-element.cart--root').forEach(element => {
        element.classList.toggle('troop-gift-cart-empty', empty);
        if (empty) {
          element.querySelectorAll('.cart--item').forEach(item => item.remove());
          console.log('[GIFT] Empty cart UI updated', element.dataset.view);
        }
      });
    }
    async verifyEmptyCart() {
      clearTimeout(this.emptyCheck);
      try {
        const latest = await this.cart();
        this.updateEmptyCart(latest);
        if (!latest.item_count) {
          this.emptyCheck = setTimeout(async () => {
            try {
              const current = await this.cart();
              this.updateEmptyCart(current);
            } catch (error) {
              console.error('[GIFT] Empty cart verification failed', error);
            }
          }, 400);
        }
      } catch (error) {
        console.error('[GIFT] Empty cart verification failed', error);
      }
    }
    watchDrawer() {
      this.installLoader();
      this.installEmptyCartStyle();
      this.ensureLoader();
      this.observer = new MutationObserver(records => {
        let updated = false;
        for (const record of records) {
          if (record.target.closest?.('.troop-gift-loading-overlay')) continue;
          const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          if (target?.closest?.('cart-element.cart--root .cart--body, cart-element.cart--root .cart--summary') || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('cart-element.cart--root, .cart--body, .cart--summary') || node.querySelector?.('cart-element.cart--root, .cart--body, .cart--summary')))) updated = true;
        }
        if (updated) {
          this.cartMutationTime = Date.now();
          this.ensureLoader();
          this.checkLoader();
        }
      });
      this.observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    async addGift(rule, addThroughTheme) {
      const id = Number(rule.freeGiftVariantId);
      const properties = { _is_free_gift: 'true', _auto_free_gift_rule: String(rule.id) };
      this.showLoader();
      console.log('[GIFT] Adding automatic gift', rule.id, id);
      if (typeof addThroughTheme === 'function') await addThroughTheme(id, properties);
      else await this.request('cart/add.js', { items: [{ id, quantity: 1, properties }] });
    }
    async remove(key) {
      this.showLoader();
      await this.request('cart/change.js', { id: key, quantity: 0 });
    }
    refreshCartUI(cart) {
      this.refreshTime = Date.now();
      if (typeof window.trigger === 'function') window.trigger('theme:cart:refresh');
      else window.dispatchEvent(new Event('theme:cart:refresh'));
      console.log('[GIFT] Requested Blockshop cart refresh', { count: cart.item_count });
      this.updateEmptyCart(cart);
      if (Number(cart.item_count) === 0) {
        clearTimeout(this.emptyCheck);
        this.emptyCheck = setTimeout(() => this.verifyEmptyCart(), 400);
      }
    }
    async sync({ addThroughTheme = null } = {}) {
      if (this.busy) { this.pending = true; return; }
      clearTimeout(this.timer);
      this.timer = null;
      this.busy = true;
      let changed = false;
      try {
        let cart = await this.cart();
        const blockedByAnotherDiscount = window.troopGiftHasOtherAutomaticDiscount(cart);
        const rule = blockedByAnotherDiscount ? null : this.matchingRule(cart);
        console.log('[GIFT] Rule check', { matched: rule?.id || null, blockedByAnotherDiscount, total: this.total(cart), freeRules: this.freeRules.length, nonFreeRules: this.nonFreeRules.length });
        for (const item of cart.items.filter(item => this.isGift(item))) {
          const correct = rule && Number(item.variant_id) === Number(rule.freeGiftVariantId) && String(item.properties?._auto_free_gift_rule) === String(rule.id) && item.quantity === 1;
          if (!correct) {
            await this.remove(item.key);
            changed = true;
            cart = await this.cart();
          }
        }
        if (rule && !cart.items.some(item => Number(item.variant_id) === Number(rule.freeGiftVariantId))) {
          await this.addGift(rule, addThroughTheme);
          changed = true;
          cart = await this.cart();

          if (window.troopGiftHasOtherAutomaticDiscount(cart)) {
            const addedGift = cart.items.find(item => this.isGift(item) &&
              String(item.properties?._auto_free_gift_rule) === String(rule.id));
            if (addedGift) {
              await this.remove(addedGift.key);
              cart = await this.cart();
            }
          }
        }
        for (const nonRule of this.nonFreeRules) {
          if (!nonRule.enabled || !Number(nonRule.freeGiftVariantId) || !this.validDate(nonRule) || nonRule.condition !== 'price') continue;
          const threshold = Number(nonRule.freeGiftPrice);
          if (!(threshold > 0) || this.total(cart) >= threshold) continue;
          const discounted = cart.items.filter(item => Number(item.variant_id) === Number(nonRule.freeGiftVariantId) && Number(item.final_price) === 0 && !this.isGift(item));
          for (const item of discounted) {
            await this.remove(item.key);
            changed = true;
            cart = await this.cart();
          }
        }
        if (changed) {
          document.dispatchEvent(new CustomEvent('troop:gift:changed', { detail: { cart, needsRefresh: true } }));
          this.refreshCartUI(cart);
        } else {
          this.updateEmptyCart(cart);
        }
      } catch (error) {
        console.error('[GIFT] Synchronization failed', error);
      } finally {
        this.busy = false;
        if (this.pending) { this.pending = false; this.schedule(); }
        else this.checkLoader();
      }
    } 
    schedule() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { this.timer = null; this.sync(); }, 300);
    }
    install() {
      const original = window.fetch;
      window.fetch = (...args) => {
        const promise = original(...args);
        const input = args[0];
        const raw = typeof input === 'string' ? input : input?.url;
        const method = String(args[1]?.method || input?.method || 'GET').toUpperCase();
        if (raw && method !== 'GET' && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(new URL(raw, location.href).pathname)) {
          this.showLoader();
          promise.then(response => {
            if (response.ok) this.schedule();
            else this.hideLoader();
          }).catch(() => this.hideLoader());
        }
        return promise;
      };
      const init = () => { this.watchDrawer(); this.schedule(); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
      else init();
      window.addEventListener('pageshow', event => { if (event.persisted) this.schedule(); });
    }
  }
  window.troopGiftManager = new TroopGiftManager();
})();
